import React from "react";
import { useTranslation } from "react-i18next";

function CalendarLegend() {
  const { t } = useTranslation();
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4 mt-4">
      <h3 className="text-gray-900 mb-2 text-sm">{t("controlManagement.calendar.legendTitle")}</h3>
      <p className="text-gray-500 text-xs mb-3">{t("controlManagement.calendar.legendSubtitle")}</p>
      <div className="flex gap-3 flex-wrap">
        <span className="px-3 py-1.5 rounded text-xs pill-blue">
          {t("controlManagement.calendar.legendTypes.preventive")}
        </span>
        <span className="px-3 py-1.5 rounded text-xs pill-purple">
          {t("controlManagement.calendar.legendTypes.detective")}
        </span>
        <span className="px-3 py-1.5 rounded text-xs pill-orange">
          {t("controlManagement.calendar.legendTypes.corrective")}
        </span>
        <span className="px-3 py-1.5 rounded text-xs pill-green">
          {t("controlManagement.calendar.legendTypes.directive")}
        </span>
      </div>
    </div>
  );
}

export default CalendarLegend;
